(() => {
  const search = document.querySelector('[data-faq-search]');
  const list = document.querySelector('[data-faq-list]');
  const empty = document.querySelector('[data-faq-empty]');
  if (!search || !list) return;

  const items = Array.from(list.querySelectorAll('[data-faq-item]'));
  const categories = Array.from(list.querySelectorAll('[data-faq-category]'));

  search.addEventListener('input', () => {
    const query = search.value.trim().toLowerCase();
    let visibleItems = 0;

    items.forEach((item) => {
      const matches = !query || item.textContent.toLowerCase().includes(query);
      item.hidden = !matches;
      if (matches) visibleItems += 1;
    });

    categories.forEach((category) => {
      category.hidden = !Array.from(category.querySelectorAll('[data-faq-item]')).some((item) => !item.hidden);
    });

    if (empty) empty.hidden = visibleItems > 0;
  });

  items.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      items.forEach((other) => {
        if (other !== item && other.open) other.open = false;
      });
    });
  });
})();
